import { ArrowRight, Wallet, CheckCircle } from "lucide-react"
import { Button } from "../ui/button"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"

const cardVariants = {
  hidden: { opacity: 0, y: 16, scale: 0.98 },
  show:   { opacity: 1, y: 0,  scale: 1, transition: { duration: 0.6, ease: "easeOut" } }
}

export default function CreditoPersonalSection() {
  const navigate = useNavigate()

  const handleSolicitarClick = () => {
    navigate("../credito-personal")
  }

  return (
    <motion.div
      variants={cardVariants}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      className="relative bg-white p-6 rounded-2xl shadow-sm border border-black/5
                 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300
                 h-full flex flex-col"
    >
      {/* Acento superior */}
      <div className="absolute inset-x-0 top-0 h-1 rounded-t-2xl bg-gradient-to-r from-[#003226] via-[#DBC5A8] to-[#003226]" />

      <div className="flex items-center gap-4 mb-4">
        {/* Badge con pulso */}
        <div className="relative">
          <div className="bg-[#DBC5A8]/70 p-3 rounded-full ring-2 ring-white shadow-md">
            <Wallet className="h-8 w-8 text-[#003226]" />
          </div>
          <div className="absolute inset-0 rounded-full animate-pulse opacity-20 bg-[#DBC5A8]" style={{ filter: "blur(8px)" }} />
        </div>

        <h3 className="text-2xl font-bold text-[#003226] tracking-tight">
          Crédito Personal
        </h3>
      </div>

      <p className="text-gray-700 mb-6 leading-relaxed">
        Conseguí el dinero para tus proyectos sin garantías: viajes, reformas,
        consolidación de deudas o imprevistos con aprobación ágil.
      </p>

      <ul className="mb-6 space-y-2">
        {[
          "Aprobación rápida en 24 horas",
          "Montos flexibles según tu perfil",
          "Sin comisiones por cancelación anticipada",
        ].map((txt) => (
          <li key={txt} className="flex items-start gap-2">
            <CheckCircle className="mt-0.5 h-5 w-5 text-[#003226]" />
            <span className="text-gray-700">{txt}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto">
        <Button
          className="w-full bg-[#003226] hover:bg-[#00291f] text-white"
          onClick={handleSolicitarClick}
        >
          Solicitar Crédito Personal
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </motion.div>
  )
}
